export default "__VITE_ASSET__C6e2tt0t__"